// PageHeader — the top of every page: optional breadcrumb, title, subtitle,
// and a right-aligned actions slot. Replaces the ad-hoc `.ph/.pt/.ps`
// markup. Wraps responsively (actions drop below the title on narrow).
//
//   <PageHeader
//     title="Placements"
//     subtitle="Active assignments, pending starts, and open requisitions"
//     icon={<Icon name="placement" size={22} />}
//     breadcrumb={[{ label: 'Home', href: '/dashboard' }, { label: 'Placements' }]}
//     actions={<Button icon={<Icon name="plus" size={15}/>}>New Requisition</Button>}
//   />

import { ReactNode } from 'react';
import Icon from './Icon';

export interface Crumb {
  label: string;
  href?: string;
}

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Leading icon element, rendered before the title. */
  icon?: ReactNode;
  actions?: ReactNode;
  breadcrumb?: Crumb[];
  className?: string;
}

export default function PageHeader({ title, subtitle, icon, actions, breadcrumb, className }: PageHeaderProps) {
  return (
    <header className={['ui-page-header', className].filter(Boolean).join(' ')}>
      <div className="ui-page-header__main">
        {breadcrumb && breadcrumb.length > 0 && (
          <nav className="ui-breadcrumb" aria-label="Breadcrumb">
            {breadcrumb.map((c, i) => (
              <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                {i > 0 && <Icon name="chevron-right" size={13} className="ui-breadcrumb__sep" />}
                {c.href ? <a href={c.href}>{c.label}</a> : <span>{c.label}</span>}
              </span>
            ))}
          </nav>
        )}
        <h1 className="ui-page-header__title">
          {icon}
          {title}
        </h1>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ui-page-header__actions">{actions}</div>}
    </header>
  );
}
